module.exports = __webpack_public_path__ + "img/ardor-hero_mob.7052fc1.webp";